import React, { useState, useEffect } from 'react';
import './ViewAR.scss';
import { getAttachRate, getOnlyAccessory, getAllUsersData } from '../../helper/helper';
import { format, startOfMonth, endOfMonth } from 'date-fns';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { storeNameList } from '../utils';
import Loader from '../../components/Loader/Loader';
import DataUnavailableMessage from '../../components/ui/DataUnavailableMessage';
import {
  // generateYearOptions,
  getLastNYearsOptions,
  removeDuplicatesByInvoice,
} from '../../components/ReusableFunctions';
import { ALL_EMPLOYEE } from '../AttachRate/AttachRate';
import { ADMIN_ROLE, EMPLYEE_ROLE, MANAGER_ROLE } from '../../components/AdminDashboard/utils';
import ViewARTable from './ViewARTable';

const ViewAR = () => {
  const username = localStorage.getItem('username');
  const userDetail = JSON.parse(localStorage.getItem('user_data') || '{}');
  const [userList, setuserList] = useState([]);
  // const [userdata, setUserdata] = useState([]);
  // const [userDetail, setUserDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [filterEmp, setFilterEmp] = useState([]);
  const [aRArray, setARArray] = useState([]);
  // const [aRArray1, setARArray1] = useState([]);
  const [employeName, setEmployeName] = useState(ALL_EMPLOYEE);

  useEffect(() => {
    async function fetchUser() {
      let { data } = await getAllUsersData();
      setuserList(data);
    }
    fetchUser();
  }, [username]);

  /* const currentDate = new Date();
    // Calculate the first day of the month
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    // Calculate the last day of the month
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    // Format the first and last day as strings (YYYY-MM-DD)
    const firstDayOfMonthString = firstDayOfMonth.toISOString().split('T')[0];
    const lastDayOfMonthString = lastDayOfMonth.toISOString().split('T')[0]; */

  // FN: use global util methods
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;
    let isActive = true;
    const handleSearch = async () => {
      setIsLoading(true);
      setEmployeName(ALL_EMPLOYEE);
      setFilterEmp([]);

      let result = [];
      let result1 = [];
      try {
        const { data } = await getAttachRate({ startDate, endDate, signal });
        const uniqueArray = removeDuplicatesByInvoice(data);

        const modifiedData = uniqueArray.map((item) => ({
          ...item,
          attachedAcc: item.attachedAcc.map((entry) => [
            ...entry,
            item.tenderedDate,
            item.saleInvoice,
          ]),
        }));

        if (modifiedData?.length > 0) {
          if (userDetail.role === MANAGER_ROLE) {
            let finalArray = [];
            userDetail?.stores?.split(',').forEach((store) => {
              userList.forEach((user) => {
                let exist = user.stores.split(',').some((item) => item === store);
                if (exist) {
                  if (!finalArray.includes(user)) {
                    finalArray.push(user);
                  }
                }
              });
            });

            // setUserdata(finalArray);
            let storesList = userDetail?.stores?.split(',');

            let filterAR = [];
            storesList.forEach((store) => {
              modifiedData.forEach((obj) => {
                const { storeInvoice, attachedAcc } = obj;
                if (storeInvoice === store && attachedAcc.length !== 0) {
                  filterAR.push(obj);
                }
              });
            });
            let employeeList = [
              ...new Set(
                filterAR?.filter((emp) => emp.user !== 'admin@vyadom.com').map((obj) => obj.user),
              ),
            ];
            setFilterEmp(employeeList);
            dataProcess(filterAR);
          } else if (userDetail.role === ADMIN_ROLE) {
            let filterAR = modifiedData?.filter((obj) => obj.attachedAcc.length !== 0);
            dataProcess(filterAR);

            // let filterEmployee = [];
            let filterEmployee = [
              ...new Set(
                filterAR?.filter((emp) => emp.user !== 'admin@vyadom.com').map((obj) => obj.user),
              ),
            ];

            setFilterEmp(filterEmployee);
          } else if (userDetail.role === EMPLYEE_ROLE) {
            let filterAR = [];
            modifiedData.forEach((obj) => {
              if (obj.user === userDetail?.username) {
                filterAR.push(obj);
              }
            });
            dataProcess(filterAR);
          }
        }

        function dataProcess(uniqueArray) {
          const groupData = (data) => {
            return data.reduce((acc, item) => {
              const {
                user,
                attachedAcc,
                aaData: { msrp, discount },
              } = item;
              if (!acc[user]) {
                acc[user] = {
                  user,
                  attachedAcc: [],
                  totalMsrp: 0,
                  totalDiscount: 0,
                };
              }
              acc[user].attachedAcc = [...acc[user].attachedAcc, ...attachedAcc];
              acc[user].totalMsrp += msrp;
              acc[user].totalDiscount += discount;

              return acc;
            }, {});
          };

          const groupedData = groupData(uniqueArray);
          result = Object.values(groupedData).map((item) => ({
            ...item,
            totalMsrpMinusDiscount: item.totalMsrp - item.totalDiscount,
          }));
        }
      } catch (error) {}
      try {
        let { data } = await getOnlyAccessory({ startDate, endDate, signal });

        let filtered = [];
        data.forEach((obj) => {
          filtered.push(obj.attachmentRateOnlyAccessory);
        });
        const uniqueArray = removeDuplicatesByInvoice(filtered, 'saleInvoiceOA');

        const modifiedData = uniqueArray.map((item) => ({
          ...item,
          attachedAccOnlyAccessory: item.attachedAccOnlyAccessory.map((entry) => [
            ...entry,
            item.tenderedDateOA,
            item.saleInvoiceOA,
          ]),
        }));

        if (modifiedData.length > 0) {
          if (userDetail.role === MANAGER_ROLE) {
            let storesList = userDetail?.stores?.split(',');
            let matchingInvoices = modifiedData
              .filter((item) => {
                // Extract the prefix part of the saleInvoiceOA
                let prefix = '';
                if (item.saleInvoiceOA !== '') {
                  prefix = item?.saleInvoiceOA.match(/^[a-zA-Z]+/)[0];
                }
                /* let prefix = item.saleInvoiceOA.match(/^[a-zA-Z]+/)[0]; */
                // Check if the extracted prefix matches any prefix in array2
                return storesList.some((prefixInArray) => prefix === prefixInArray);
              })
              .map((item) => item);
            dataProcess(matchingInvoices);
          } else if (userDetail.role === ADMIN_ROLE) {
            dataProcess(modifiedData);
          } else if (userDetail.role === EMPLYEE_ROLE) {
            let filterAR = [];
            modifiedData.forEach((obj) => {
              if (obj.username === userDetail?.username) {
                filterAR.push(obj);
              }
            });
            dataProcess(filterAR);
          }
        }

        function dataProcess(filtered) {
          const groupData = (data) => {
            return data.reduce((acc, item) => {
              const {
                username,
                attachedAccOnlyAccessory,
                aaDataOnlyAccessory: { msrp, discount },
              } = item;
              if (!acc[username]) {
                acc[username] = {
                  username,
                  attachedAcc: [],
                  totalMsrp: 0,
                  totalDiscount: 0,
                };
              }
              acc[username].attachedAcc = [
                ...acc[username].attachedAcc,
                ...attachedAccOnlyAccessory,
              ];
              acc[username].totalMsrp += msrp;
              acc[username].totalDiscount += discount;
              return acc;
            }, {});
          };

          // Grouped data
          const groupedData = groupData(filtered);

          // Calculate total MSRP minus discount for each specialist
          result1 = Object.values(groupedData).map((item) => ({
            ...item,
            totalMsrpMinusDiscount: item.totalMsrp - item.totalDiscount,
          }));
        }
      } catch (error) {}

      if (isActive) {
        // Check if the component is still active
        const mergedData = mergeUserData(result, result1);

        if (mergedData) {
          setARArray(mergedData);
          // setARArray1(mergedData);
        }
        setIsLoading(false);
      }
    };

    if (startDate && endDate) {
      handleSearch();
    }
    return () => {
      isActive = false;
      controller.abort();
    };
  }, [startDate, endDate, userDetail.role, userDetail?.stores, userDetail?.username, userList]);

  const generateMonths = () => {
    return [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
  };

  const months = generateMonths();
  const years = getLastNYearsOptions();
  const [selectedMonth, setSelectedMonth] = useState(months[new Date().getMonth()]);
  const [selectedYear, setSelectedYear] = useState(years[0]);

  useEffect(() => {
    // Update startDate and endDate when selectedMonth or selectedYear changes
    const selectedMonthIndex = months.findIndex((month) => month === selectedMonth);
    const selectedDate = new Date(selectedYear, selectedMonthIndex);

    setStartDate(format(startOfMonth(selectedDate), 'yyyy-MM-dd'));
    if (selectedMonth === format(new Date(), 'MMMM') && selectedYear === new Date().getFullYear()) {
      // If current month and year, set endDate to today
      setEndDate(format(new Date(), 'yyyy-MM-dd'));
    } else {
      // Otherwise, set endDate to the last day of the selected month
      setEndDate(format(endOfMonth(selectedDate), 'yyyy-MM-dd'));
    }
  }, [selectedMonth, selectedYear, months]);

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const mergeUserData = (list1, list2) => {
    // Create a map for quick lookup of users in list2 by username
    const userMap = list2.reduce((acc, userObj2) => {
      acc[userObj2.username] = userObj2;
      return acc;
    }, {});

    // Create a new list to store the merged data
    const mergedData = [];

    // Iterate through list1 and merge data if there's a matching user in list2
    list1.forEach((userObj1) => {
      const matchingUser = userMap[userObj1.user];
      if (matchingUser) {
        mergedData.push({
          user: userObj1.user,
          attachedAcc: {
            list1: /* removeCopies(userObj1.attachedAcc) */ userObj1.attachedAcc,
            list2: /*  removeCopies(matchingUser.attachedAcc) */ matchingUser.attachedAcc,
          },

          totalMsrpMinusDiscount: {
            list1: userObj1.totalMsrpMinusDiscount,
            list2: matchingUser.totalMsrpMinusDiscount,
          },
        });
        // Remove the matched user from the map to avoid duplicates
        delete userMap[userObj1.user];
      } else {
        mergedData.push({
          user: userObj1.user,
          attachedAcc: {
            list1: /* removeCopies(userObj1.attachedAcc) */ userObj1.attachedAcc,
            list2: [],
          },
          totalMsrpMinusDiscount: {
            list1: userObj1.totalMsrpMinusDiscount,
            list2: 0,
          },
        });
      }
    });
    return mergedData;
  };

  const capitalizeFirstLetter = (string) => {
    if (string.length === 7) {
      return storeNameList[string];
    } else {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase().slice(0, -11);
    }
  };

  const handleEmployeeNameChange = (e) => {
    e.preventDefault();
    setEmployeName(e.target.value);
  };

  let selectedEmployeeAR =
    employeName !== ALL_EMPLOYEE ? aRArray.filter((emp) => emp.user === employeName) : aRArray;
  let sortedEmployeeAR = [...selectedEmployeeAR].sort((a, b) => {
    const aVal = Number(a.totalMsrpMinusDiscount?.list1?.toFixed(2)) || 0;
    const bVal = Number(b.totalMsrpMinusDiscount?.list1?.toFixed(2)) || 0;
    return bVal - aVal;
  });
  let sortedEmp = [...filterEmp].sort((a, b) => a.localeCompare(b));

  // Todo: remove when layout page scroll is handled
  useEffect(() => {
    const pageContainers = document.getElementsByClassName('page-container');
    if (pageContainers.length > 0) {
      pageContainers[0].style.overflowY = 'hidden';
    }
    return () => {
      if (pageContainers.length > 0) {
        pageContainers[0].style.overflowY = 'scroll';
      }
    };
  }, []);

  return (
    <div className="var-main">
      <div className="var-container">
        <div className="var-block-container">
          <div className="filter-menu-list">
            <div className="filter-menu">
              <div className="filter-datemenu">
                <p>Select Month:</p>
                <Select
                  id="monthSelect"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  name="monthSelect"
                  displayEmpty
                  className="filter-datemenu-select"
                  fullWidth
                >
                  {months.map((month, index) => (
                    <MenuItem key={index} value={month}>
                      {month}
                    </MenuItem>
                  ))}
                </Select>
                <p>Select Year:</p>
                <Select
                  id="yearSelect"
                  name="_yearSelect"
                  value={selectedYear}
                  onChange={handleYearChange}
                  displayEmpty
                  className="filter-datemenu-select"
                  fullWidth
                >
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            {userDetail?.role !== 'employee' && (
              <div className="filter-menu-employee">
                <div className="filter-employee">
                  <FormControl fullWidth>
                    <InputLabel
                      htmlFor="employeeFilter"
                      id="employeeFilter-label"
                      disabled={isLoading || sortedEmp?.length === 0}
                      className="label-white"
                    >
                      Select Employee
                    </InputLabel>
                    <Select
                      labelId="employeeFilter-label"
                      value={employeName}
                      onChange={handleEmployeeNameChange}
                      className="filter-datemenu-select"
                      // label="Select Employee"
                      name="employeeFilter"
                      inputProps={{
                        id: 'employeeFilter',
                      }}
                      disabled={isLoading || sortedEmp?.length === 0}
                    >
                      {sortedEmp.length !== 1 && (
                        <MenuItem value={ALL_EMPLOYEE}>
                          <em>All Employee</em>
                        </MenuItem>
                      )}
                      {sortedEmp &&
                        sortedEmp?.map((name, index) => (
                          <MenuItem key={index} value={name}>
                            {capitalizeFirstLetter(name)}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            )}
          </div>
          <div>
            {isLoading ? (
              <Loader />
            ) : !sortedEmployeeAR || sortedEmployeeAR?.length === 0 ? (
              <DataUnavailableMessage
                customMessage={`The requested data for ${selectedMonth} ${selectedYear} is currently unavailable.`}
              />
            ) : (
              <ViewARTable
                sortedEmployeeAR={selectedEmployeeAR}
                capitalizeFirstLetter={capitalizeFirstLetter}
              />
            )}
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default ViewAR;
